import React from "react";
import {
    CardCheckbox,
    CardContent,
    EmptyState,
    FieldLabel,
    FieldValue,
    HeaderContainer,
    PacketCount,
    PacketNumber,
    ReceiverAddress,
    ReceiverName,
    ShipmentCard,
    ShipmentField,
    ShipmentList,
    ShipmentRow,
    StyledCheckbox,
    StyledDivider,
    StyledTag,
    StyledTagStatus,
    SummaryContainer
} from "../ShipmentTransferModal.styled";
import {Typography} from "antd";
import {CheckCircleOutlined, InfoCircleOutlined} from "@ant-design/icons";
const {Text} = Typography;

export const AcceptableMoveShipmentTable = ({
    transfer,
    selectedShipments,
    setSelectedShipments
}) => {
    const handleShipmentSelect = (shipmentId, checked) => {
        if (checked) {
            setSelectedShipments(prev => [...prev, shipmentId]);
        } else {
            setSelectedShipments(prev => prev.filter(id => id !== shipmentId));
        }
    };

    const handleSelectAll = checked => {
        if (checked) {
            const allShipmentIds = transfer?.shipmentDetails?.map(s => s._id) || [];
            setSelectedShipments(allShipmentIds);
        } else {
            setSelectedShipments([]);
        }
    };

    const getStatusTag = status => {
        switch (status) {
            case "inTransit":
                return <StyledTagStatus color="blue">Yolda</StyledTagStatus>;
            case "created":
                return <StyledTagStatus color="green">Oluşturuldu</StyledTagStatus>;
            case "calculated":
                return <StyledTagStatus color="orange">Hesaplandı</StyledTagStatus>;
            case "readyToTransfer":
                return <StyledTagStatus color="gold">Transfer Hazır</StyledTagStatus>;
            default:
                return <StyledTagStatus color="purple">Tamamlandı</StyledTagStatus>;
        }
    };

    return (
        <>
            <HeaderContainer>
                <StyledCheckbox
                    onChange={e => handleSelectAll(e.target.checked)}
                    checked={
                        selectedShipments.length === transfer?.shipmentDetails?.length &&
                        transfer?.shipmentDetails?.length > 0
                    }
                    indeterminate={
                        selectedShipments.length > 0 &&
                        selectedShipments.length < (transfer?.shipmentDetails?.length || 0)
                    }
                >
                    Tümünü Seç
                </StyledCheckbox>

                <Text type="secondary">
                    {selectedShipments.length} / {transfer?.shipmentDetails?.length || 0} seçildi
                </Text>
            </HeaderContainer>
            <StyledDivider />
            <ShipmentList>
                {transfer?.shipmentDetails?.map(shipment => (
                    <ShipmentCard
                        key={shipment.vigoBarcodeNumber}
                        selected={selectedShipments.includes(shipment._id)}
                    >
                        <CardCheckbox
                            checked={selectedShipments.includes(shipment._id)}
                            onChange={e => handleShipmentSelect(shipment._id, e.target.checked)}
                        />
                        <CardContent>
                            <ShipmentRow>
                                <ShipmentField>
                                    <FieldLabel strong>Barkod:</FieldLabel>
                                    <FieldValue>
                                        <StyledTag color="cyan">
                                            {shipment?.barcodeNumber}
                                        </StyledTag>
                                    </FieldValue>
                                </ShipmentField>

                                <ShipmentField>
                                    <FieldLabel strong>Paket Sayısı:</FieldLabel>
                                    <FieldValue>
                                        <PacketCount>
                                            <PacketNumber>{shipment?.packageCount}</PacketNumber>{" "}
                                            Paket
                                        </PacketCount>
                                    </FieldValue>
                                </ShipmentField>

                                <ShipmentField>
                                    <FieldLabel strong>Müşteri Adı:</FieldLabel>
                                    <FieldValue>
                                        <ReceiverName>
                                            {shipment?.receiver?.name || "-"}
                                        </ReceiverName>
                                    </FieldValue>
                                </ShipmentField>

                                <ShipmentField>
                                    <FieldLabel strong>Müşteri Adresi:</FieldLabel>
                                    <FieldValue>
                                        <ReceiverAddress>
                                            {shipment?.receiver?.address || "-"}
                                        </ReceiverAddress>
                                    </FieldValue>
                                </ShipmentField>

                                <ShipmentField>
                                    <FieldLabel strong>Durum:</FieldLabel>
                                    <FieldValue>{getStatusTag(shipment?.status)}</FieldValue>
                                </ShipmentField>
                            </ShipmentRow>
                        </CardContent>
                    </ShipmentCard>
                ))}
            </ShipmentList>
            {transfer?.shipmentDetails?.length === 0 && (
                <EmptyState>
                    <InfoCircleOutlined style={{fontSize: "32px", marginBottom: "16px"}} />
                    <p>Aktarılacak shipment bulunamadı.</p>
                </EmptyState>
            )}
            {selectedShipments.length > 0 && (
                <SummaryContainer>
                    <CheckCircleOutlined style={{color: "#52c41a", marginRight: "8px"}} />
                    <Text>{selectedShipments.length} adet shipment transfer için hazır</Text>
                </SummaryContainer>
            )}
        </>
    );
};
